const captcha = {
  recaptcha: 'La vérification reCAPTCHA a échouée. Veuillez réessayer.',
  recaptchaNotAvailable:
    'Impossible de terminer la vérification. Veuillez actualiser la page et réessayer.',
  recaptchaInvalid: 'La vérification a échouée. Veuillez réessayer.',
  recaptchaUnexpected:
    'Impossible de compléter votre demande. Veuillez réessayer plus tard.',
};

export default captcha;
